import React, { useEffect } from 'react'

declare global {
  interface Window {
    ezstandalone?: {
      cmd?: Array<() => void>
      showAds?: (...ids: number[]) => void
    }
  }
}

interface EzoicAdBatchProps {
  placementIds: number[]
}

const EzoicAdBatch: React.FC<EzoicAdBatchProps> = ({ placementIds }) => {
  useEffect(() => {
    const ezoicStandalone = window.ezstandalone
    if (!ezoicStandalone) return

    ezoicStandalone.cmd = ezoicStandalone.cmd || []
    ezoicStandalone.cmd.push(() => {
      ezoicStandalone.showAds?.(...placementIds)
    })
  }, [placementIds])

  return null
}

export default EzoicAdBatch
